import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import AsControl from '../AsControl';
import PureTextArea from './TextArea';

export const TextArea = AsControl()(PureTextArea);
export const TextAreaControl = bindControlToForm()(TextArea);
export const AutoSavedTextAreaControl = autoSaved({ saveOnBlur: true })(TextAreaControl);
